import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=07c7c3eb&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c7c3eb')) {
      api.createRecord('07c7c3eb', component.options)
    } else {
      api.reload('07c7c3eb', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=07c7c3eb&", function () {
      api.rerender('07c7c3eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2um1A7Cx97CKh/JS/comp/stardisplay.vue"
export default component.exports